import React from 'react';
import { connect } from 'react-redux';

import SidebarProfile from './SidebarProfile';
import SidebarMenus from './SidebarMenus';

export const Sidebar = ({ user }) => (
  <div id="sidebar" className="sidebar">
    <div data-scrollbar="true" data-height="100%">
      <SidebarProfile user={user} />
      <SidebarMenus />
    </div>
  </div>
);

const mapStateToProps = state => ({
  user: state.auth.user,  
});

export default connect(mapStateToProps)(Sidebar);
